import React from 'react';

const TRACEABILITY_TOOLTIP =
  'Bloque reconstruido o ajustado por el sistema para asegurar coherencia pedagógica.';

type TraceableSource = 'sanitized' | 'factory';

function resolveTraceabilitySource(payload: unknown): TraceableSource | null {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
  const source = (payload as { _meta?: { source?: unknown } })._meta?.source;
  if (source === 'sanitized' || source === 'factory') return source;
  return null;
}

function SparkleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M9.813 1.75a.75.75 0 0 1 .374 0l1.43.715 1.43-.715a.75.75 0 0 1 1.058.858l-.357 1.608 1.429.715a.75.75 0 0 1 0 1.342l-1.43.715.357 1.608a.75.75 0 0 1-1.058.858l-1.43-.715-1.43.715a.75.75 0 0 1-1.058-.858l.357-1.608-1.429-.715a.75.75 0 0 1 0-1.342l1.43-.715-.357-1.608a.75.75 0 0 1 .685-.858ZM4.5 11.25a.75.75 0 0 1 .53.22l1.28 1.28 1.28-1.28a.75.75 0 1 1 1.06 1.06l-1.28 1.28 1.28 1.28a.75.75 0 1 1-1.06 1.06l-1.28-1.28-1.28 1.28a.75.75 0 1 1-1.06-1.06l1.28-1.28-1.28-1.28a.75.75 0 0 1 .53-1.28Z" />
    </svg>
  );
}

export function BlockTraceabilityIndicator({ payload }: { payload: unknown }) {
  const source = resolveTraceabilitySource(payload);
  if (!source) return null;

  return (
    <span
      title={TRACEABILITY_TOOLTIP}
      className="inline-flex shrink-0 items-center text-indigo-900/40 transition-colors hover:text-indigo-900/55"
      role="img"
      aria-label={TRACEABILITY_TOOLTIP}
    >
      <SparkleIcon className="h-4 w-4" />
    </span>
  );
}
